import ServerDirections from '@/config/server-directions'
import { RequestService } from '@/services/request.service'
import { APP_FACILITY_ID, APP_SERVICE_ID } from '@/config/environment'
import { DashboardPage } from '@/entities/webapp-pages/DashboardPage'
import { WebappPage } from '@/entities/webapp-pages/WebappPage'
import { OpeningHours } from '@/entities/webapp-pages/OpeningHours'
import { Slot } from '@/entities/activities/Slot'
import { UpcomingEvent } from '@/entities/webapp-pages/UpcomingEvent'
import moment from 'moment'

const requestService = new RequestService()

export class PageRequests {
  getDashboardItems () {
    const route = ServerDirections.DASHBOARD_PAGES.replace('{serviceId}', APP_SERVICE_ID)
    const method = 'get'
    function map (data) {
      return data.map((page) => new DashboardPage(page)).filter((item) => {
        if (item.page) {
          return item.page.active
        }
        return true
      })
    }
    return requestService.makePromise(route, method, { noAuth: true }, map)
  }
  get (id) {
    const route = ServerDirections.WEBAPP_PAGES_ID.replace('{id}', id)
    const method = 'get'
    function map (data) {
      return new WebappPage(data)
    }
    return requestService.makePromise(route, method, { noAuth: true }, map)
  }
  getPageOpeningHours (pageId, { start, end, date }) {
    const route = ServerDirections.PAGE_ID_OPENING_HOURS.replace('{pageId}', pageId)
    const method = 'get'
    function map (data) {
      return data.map((item) => {
        return new OpeningHours(item)
      })
    }
    let params = {}
    if (date) {
      params.start_date = date
      params.end_date = date
    } else {
      params.start_date = start
      params.end_date = end
    }
    return requestService.makePromise(route, method, { params, noAuth: true }, map)
  }
  getOpeningHours (startDate, endDate, activityCategoryIds) {
    const route = ServerDirections.OPENING_HOURS
    const method = 'get'
    function map (data) {
      return data.map((item) => {
        return new UpcomingEvent(item)
      })
    }
    let params = {
      start_date: startDate,
      end_date: endDate,
      start_time: moment.duration(moment().format('HH:mm'), 'HH:mm').asMilliseconds(),
      facility_id: APP_FACILITY_ID,
    }
    if (activityCategoryIds && activityCategoryIds.length) {
      params.activity_category_ids = activityCategoryIds.toString()
    }
    return requestService.makePromise(route, method, { params, noAuth: true }, map)
  }
  getSlots (pageId, date) {
    const route = ServerDirections.PAGE_ID_SLOTS.replace('{pageId}', pageId)
    const method = 'get'
    function map (data) {
      return new Slot(data)
    }
    const params = {
      date: moment(date, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss.SSS+0000'),
    }
    return requestService.makePromise(route, method, { params }, map)
  }
}
